import styled from '@emotion/styled'

import { useTheme } from '@emotion/react'

import Image from '@segment/matcha/components/Image'

import personalizeOnEveryChannelPng from './assets/PersonalizeOnEveryChannel.png'
import personalizeOnEveryChannelPng2x from './assets/PersonalizeOnEveryChannel@2x.png'
import personalizeOnEveryChannelWebp from './assets/PersonalizeOnEveryChannel.webp'
import personalizeOnEveryChannelWebp2x from './assets/PersonalizeOnEveryChannel@2x.webp'

import personalizeOnEveryChannelMobilePng2x from './assets/PersonalizeOnEveryChannelMobile@2x.png'
import personalizeOnEveryChannelMobileWebp from './assets/PersonalizeOnEveryChannelMobile.webp'
import personalizeOnEveryChannelMobileWebp2x from './assets/PersonalizeOnEveryChannelMobile@2x.webp'

const PersonalizeOnEveryChannelImage = () => {
  const theme = useTheme()
  return (
    <Picture>
      <source
        type="image/webp"
        media={theme.breakpoints.up(`lg`, false)}
        srcSet={`${personalizeOnEveryChannelWebp}, ${personalizeOnEveryChannelWebp2x} 2x`}
        width="624"
        height="404"
      />
      <source
        media={theme.breakpoints.up(`lg`, false)}
        srcSet={`${personalizeOnEveryChannelPng}, ${personalizeOnEveryChannelPng2x} 2x`}
        width="624"
        height="404"
      />
      <source
        type="image/webp"
        srcSet={`${personalizeOnEveryChannelMobileWebp}, ${personalizeOnEveryChannelMobileWebp2x} 2x`}
        width="315"
        height="556"
      />
      <Image
        src={personalizeOnEveryChannelMobilePng2x}
        alt="Illustration: Personalize on every channel"
        width="315"
        height="556"
        loading="lazy"
      />
    </Picture>
  )
}

const Picture = styled.picture`
  filter: drop-shadow(${({ theme }) => theme.shadows[2]});
`

export default PersonalizeOnEveryChannelImage
